import Button from '@mui/material/Button';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Dialog from '@mui/material/Dialog';

export interface PropertySpyStopConfirmationDialogProps {
    id?: string;
    keepMounted: boolean;
    value?: string;
    open: boolean;
    onCancel?: (value?: string) => void;
    onOk?: (value?: string) => void;
}

export const PropertySpyStopConfirmationDialog = (props: PropertySpyStopConfirmationDialogProps): JSX.Element => {
    const { 
        onCancel, 
        onOk, 
        value, 
        open, 
        ...other 
    } = props;

    const handleCancel = (event: any) => {
        onCancel?.()
    };

    const handleOk = (event: any) => {
        onOk?.()
    };

    return (
        <>
            <Dialog
                sx={{ '& .MuiDialog-paper': { width: '80%', maxHeight: 435 } }}
                maxWidth="xs"
                open={open}
                {...other}
            >
                <DialogTitle>Stop spying confirmation</DialogTitle>
                <DialogContent dividers>
                    <p>Are you sure you want to stop spying this property?</p>
                </DialogContent>
                <DialogActions>
                    <Button autoFocus onClick={handleCancel}>
                        Keep
                    </Button>
                    <Button
                        color="error"
                        size="small"
                        variant="contained"
                        onClick={handleOk}>Stop Spy
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}